import Layers from "slotworks/graphics/layers/layers";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import autoplayModel from "slotworks/model/autoplay-model";

export default class DisabledSpinButtonBehaviour extends AbstractButtonBehaviour {

    public init() {
        Layers.SmartButton.defaultScene().execute();
        this.button = Layers.SmartButton.getFlexiButton("spin");
        this.button.setEnabled(false);

        const autoButton = Layers.SmartButton.getFlexiButton("auto_start");
        if (autoButton) {
            autoButton.setEnabled(false);
            if(autoplayModel.autoplayDisabled) {
                autoButton.setVisible(false);
            }
        }
    }

    public destroy() {
        super.destroy();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/disabled-spin-button-behaviour.ts